export default __webpack_public_path__ + "a5d4ecde9c9af1cf9a27bd1b77409f03.svg";